module.exports = __webpack_public_path__ + "img/features_15.a9a009e3.png";